export default {
  getURL: 'appBlackoutsPostalCodesCatalog',
  // createURL: 'appId/areaId/appContentFromCatalog',
  sessionParams: ['appId', 'areaId'],
  loadPage:'appId/areaId/appContent?page=last',
  canEdit: false,
  canOpen: false,
  isMultiSelectable: true,
  fields: [
    {
      attributeName: 'countryName',
      helpText: 'Country.',
      label: 'Country',
      canFilter: true,
    },
    {
      attributeName: 'name',
      helpText: 'Name of the group.',
      label: 'Name',
      canFilter: true,
    },
    {
      attributeName: 'postalCodes',
      helpText: 'Postal codes.',
      label: 'Postal codes',
      canFilter: true,
    },

  ],
};
